import Controller from '@ember/controller';
import { action } from '@ember/object';
import { service } from '@ember/service';

export default class JournalReportController extends Controller {
  @service declare powerMenu: any;

  powerMenuOptions() {
    return [
      {
        label: 'Journal > Stages',
        route: 'funds.fund.journals.journal.index',
      },
    ];
  }

  @action
  templateDidInsert() {
    this.powerMenu.prependOptionsFn('journal-report', this.powerMenuOptions);
  }

  @action
  templateWillDestroy() {
    this.powerMenu.removeOptions('journal-report');
  }
}
